import base from "@/store/utils/api-route/base";

const reminderPoint = `${base.promoProxy}/settings/reminder-poin`

const api = {
    pengaturanUmum: `${base.masterData}owner/get_pengaturan_umum`,
    index:  `${base.masterData}owner/get_pengaturan_umum_owner`,
    settingsV2: `${base.promoProxy}/settings`,
    pengaturanRekomendasiLayanan: `${base.masterData}owner/pengaturan-rekomendasi-layanan`,
    epayment: {
        updateData: `${base.masterData}owner/edit_pengaturan_umum`,
        listPenyesuaian: `${base.masterData}owner/get_data_paket_emoney_need_update`,
        updateMasaAktifEpaymentLimited: `${base.masterData}owner/update_masaaktif_paket_emoney_limited`,
    },
    reminder: {
        option: `${base.masterData}owner/data_master_pengingat_masaaktif`,
        info: `${base.masterData}owner/pengaturan_umum_masaaktif`,
        setting: `${base.masterData}owner/simpan_pengaturan_pengingat_masaaktif`,
        deposit: {
            create: `${base.masterData}owner/tambah_pengingat_masaaktif_deposit`,
        },
        epayment: {
            create: `${base.masterData}owner/tambah_pengingat_masaaktif_epayment`,
        },
        point: {
            create: `${reminderPoint}`,
            update: id => `${reminderPoint}/${id}/reminder`,
            deviceSetting: `${reminderPoint}/device`, 
            changeStatus: `${reminderPoint}/changeStatus`, 
        },
        detail: `${base.masterData}owner/data_detail_pengingat_masaaktif`,
        update: `${base.masterData}owner/update_data_pengingat_masaaktif`,
        delete: `${base.masterData}owner/delete_data_pengingat_masaaktif`,
        perangkat: `${base.masterData}owner/simpan_perangkat_pengingat_masaaktif`,
    },
    laporan: {
        getListData: `${base.masterData}owner/list_sumber_dana_item_biaya`,
        updateSumberDana: `${base.masterData}owner/update_status_hide_sumber_dana`,
        updateItemBiaya: `${base.masterData}owner/update_status_hide_item_biaya`,
    },
    customer_ambil_dan_lunasi: {
        index: `${base.masterData}owner/get_customer_ambil_dan_lunasi`,
        update: `${base.masterData}owner/update_customer_ambil_dan_lunasi`,
    },
    pelunasanInvoice: {
        updateSetting: `${base.masterData}owner/update_setting_can_paidoff_invoice`,
        updateOutletCanPaidOff: `${base.masterData}owner/save_setting_outlet_employ_can_paidoff_invoice`,
        listOutletCanPaidOff: `${base.masterData}owner/meta/list_setting_outlet_can_paidoff_invoice`,
        getListCashirOutlet: `${base.masterData}owner/meta/list_karyawan`,
        updateSettingAutoGenerateQrisInvoice: `${base.masterData}owner/update_setting_auto_generate_qris_invoice` ,
    },
    WaVerification: {
        update: `${base.promoProxy}/settings/member-registration/verifwa`,
    },
    acticePeriodCashback: {
        index: `${base.promoProxy}/settings/active-period-cashback`,
    },
    activePeriodpoint: {
        index: `${base.promoProxy}/settings/active-period-poin`,
    },
    ownerPengaturanNota: `${base.masterData}owner/owner_pengaturan_nota`,
};

export default api;